<template>
  <v-container class="form-container" style="overflow: auto; height: calc(100vh - 48px)">
    <v-row no-gutters>
      <v-btn small icon outlined color="primary" @click="$router.back()" class="mr-4">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h3>{{ ctrl.formData.questionContent[0].question }}</h3>
    </v-row>

    <v-divider class="my-1"></v-divider>

    <v-row no-gutters>
      <v-col cols="8" class="pr-2">
        <label class="subtitle-2">Question</label>
        <v-text-field dense outlined v-model="ctrl.formData.questionContent[0].question"
          @blur="ctrl.update(ctrl.formData)"></v-text-field>
      </v-col>
      <v-col cols="4" class="pl-2">
        <label class="subtitle-2">Type</label>

        <v-select :items="ctrl.questionTypes" dense outlined v-model="ctrl.formData.questionType"
          @change.capture="setQuestionType"></v-select>
      </v-col>
    </v-row>

    <component :is="getQuestionTypeComponent()" :updateQuestion="ctrl.update" :question="ctrl.formData" />

  </v-container>
</template>

<script>
  import yesNo from "./questionTypes/yes-no";
  import multiple from "./questionTypes/multiple";
  import rating from "./questionTypes/rating";

  export default {
    data() {
      return {
        ctrl: this.get_controller("questionnaire_question"),
        components: {
          "yes-no": yesNo,
          multiple: multiple,
          rate: rating,
        },
      };
    },
    mounted() {
      this.ctrl.getQuestion(this.$route.params.questionId);
    },
    methods: {
      setQuestionType() {
        this.ctrl.formData.setQuestionType();
        this.ctrl.update(this.ctrl.formData);
      },
      getQuestionTypeComponent() {
        var qT = this.ctrl.questionTypes.find(
          (qt) => qt.value == this.ctrl.formData.questionType
        );

        return this.components[qT.componentName];
      },
    },
  };
</script>

<style>
</style>